import { render, staticRenderFns } from "./TabsItem.vue?vue&type=template&id=6a162ed9&"
import script from "./TabsItem.vue?vue&type=script&lang=js&"
export * from "./TabsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports